(() => {
  const plain = (item) => !item.selling_plan_allocation && !item.selling_plan && !Object.keys(item.properties || {}).length;
  function replacement(cart, singleId, setId) {
    const singles = cart.items.filter((item) => String(item.variant_id) === String(singleId));
    if (singles.length !== 1 || singles[0].quantity !== 1 || !plain(singles[0]) ||
        cart.items.some((item) => String(item.variant_id) === String(setId) ||
          (item.product_id === singles[0].product_id && /set/i.test(item.variant_title || '')))) {
      throw new Error('Your cart changed. View your cart before choosing a set.');
    }
    return { old: singles[0], updates: { [singles[0].key]: 0, [setId]: 1 } };
  }
  const signature = (item) => JSON.stringify([String(item.variant_id), item.quantity, item.properties || {}, item.selling_plan_allocation || null]);
  function verified(before, after, old, setId) {
    const set = after.items.filter((item) => String(item.variant_id) === String(setId));
    if (set.length !== 1 || set[0].quantity !== 1 || !plain(set[0]) || after.items.some((item) => String(item.variant_id) === String(old.variant_id))) return false;
    const remaining = before.items.filter((item) => item.key !== old.key).map(signature).sort();
    const actual = after.items.filter((item) => String(item.variant_id) !== String(setId)).map(signature).sort();
    return JSON.stringify(remaining) === JSON.stringify(actual);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { replacement, verified };
  if (typeof document === 'undefined') return;
  let busy = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-aura-set-upgrade]');
    if (!button || button.disabled || busy) return;
    busy = true; button.disabled = true;
    const status = button.parentElement.querySelector('[data-aura-upgrade-status]');
    const root = window.Shopify?.routes?.root || '/';
    let submitted = false;
    const read = async (url) => { const response = await fetch(url, {headers:{Accept:'application/json'}, cache:'no-store'}); if (!response.ok) throw new Error('Unable to read your cart.'); return response.json(); };
    const viewCart = () => { const link = document.createElement('a'); link.href = `${root}cart`; link.textContent = ' View cart'; status.append(link); };
    status.textContent = 'Checking your cart…';
    try {
      const before = await read(`${root}cart.js`);
      const plan = replacement(before, button.dataset.singleId, button.dataset.setId);
      submitted = true;
      const response = await fetch(`${root}cart/update.js`, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:plan.updates})});
      // A submitted request is never automatically retried, even on an error response.
      if (!response.ok) throw new Error('The upgrade could not be confirmed. Please review your cart.');
      const after = await read(`${root}cart.js`);
      if (!verified(before, after, plan.old, button.dataset.setId)) throw new Error('Your cart needs review before continuing.');
      document.querySelectorAll('[data-aurasync-cart-count]').forEach((node) => {node.textContent = after.item_count;});
      const sections = await read(`${root}?sections=cart-drawer-section`);
      const current = document.getElementById('shopify-section-cart-drawer-section');
      if (!current || !sections['cart-drawer-section']) { window.location.assign(`${root}cart`); return; }
      current.outerHTML = sections['cart-drawer-section'];
      const drawer = document.getElementById('cart-drawer');
      if (typeof drawer?.open === 'function') drawer.open();
      else window.location.assign(`${root}cart`);
      status.textContent = 'Upgraded to the set.';
    } catch (error) {
      status.textContent = submitted ? 'Upgrade status needs review. Please check your cart before making another change.' : error.message;
      viewCart();
      // Keep stale controls disabled on all failures; a cart refresh establishes a new state.
    } finally { busy = false; }
  });
})();
